<template>
  <div>
    <div class="form-group">
      <slot v-if="$slots['label']" name="label" />
      <label v-else>{{ label }}</label>
      <div v-if="preselectedArtwork && preselectedArtwork.path" class="selected-artwork">
        <img :src="preselectedArtwork.thumbnail_path || preselectedArtwork.path" width="100%">
      </div>

      <div class="mt-1 d-flex">
        <button type="button"
                class="btn btn-ss flex-grow-1"
                @click="showModal">
          {{ button_text }}
        </button>
        <button v-if="clearable && preselectedArtwork && preselectedArtwork.path"
                type="button"
                class="btn btn-ss-cancel ml-2"
                @click="clearArtwork">
          Clear
        </button>
      </div>
    </div>
    <artwork-selection-modal :name="modal_name"
                             :preselected-artwork="preselectedArtwork"
                             :preloaded-artworks="preloadedArtworks"
                             :feed-suitable-only="feedSuitableOnly"
                             :banner-suitable-only="bannerSuitableOnly"
                             :lock-suitability="lockSuitability"
                             reset-on-close />
  </div>
</template>

<script>
import ArtworkSelectionModal from "VueModals/ArtworkSelectionModal";

const getNextId = (function () {
  let id = 0;
  return () => id++;
})();

export default {
  components: { ArtworkSelectionModal },
  props: {
    modalName: {
      type: String,
      required: false,
      default: null,
    },
    preselectedArtwork: {
      type: Object,
      required: false,
      default: function () {
        return {
          path: '/build/media/misc/no-image.png',
        };
      },
    },
    preloadedArtworks: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    label: {
      type: String,
      required: false,
      default: 'Artwork',
    },
    feedSuitableOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    bannerSuitableOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    lockSuitability: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    modal_name() {
      return this.modalName ?? `artwork-selection-modal-${getNextId()}`;
    },
    artwork_to_display() {
      if (this.selected_artwork?.uuid) {
        return this.selected_artwork;
      } else if (this.preselectedArtwork?.uuid) {
        return this.preselectedArtwork;
      }

      return {
        path: '/build/media/misc/no-image.png',
      };
    },
    button_text() {
      const change_state = this.selected_artwork || this.preselectedArtwork;
      return `${change_state ? 'Change' : 'Select'} ${this.label}`;
    },
  },
  methods: {
    async showModal() {
      const res = await this.fireModal(this.modal_name);
      this.$emit('selected', {
        selected_artwork: this.preselectedArtwork,
        ...res.data,
      });
    },
    clearArtwork() {
      this.$emit('selected', { selected_artwork: null });
    },
  },
};
</script>
